import src from "IMAGE";
export default { src, width: 1280, height: 212, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
